/**
 * Group edition screenings by the VOD media id stored on each screening.
 * Screenings without a usable id stay in the counters only.
 */

const media_id_text = (value) => {
    if (value == null)
        return null;
    const text = String(value).trim();
    return text || null;
};

export const shift72_media_id = (screening) => (
    media_id_text(screening?.opaque?.shift72?.media_id)
);

export const own_it_media_id = (screening) => {
    const refs = screening?.refs;
    if (!Array.isArray(refs))
        return null;

    for (const ref of refs) {
        if (!ref || ref.source !== 'dac-player')
            continue;
        const id = media_id_text(ref.id);
        if (id)
            return id;
    }

    return null;
};

const start_ms = (screening) => {
    const value = screening?.start_at;
    if (value == null)
        return Number.MAX_SAFE_INTEGER;

    const ms = typeof value.valueOf === 'function' ? value.valueOf() : Date.parse(value);
    return Number.isFinite(ms) ? ms : Number.MAX_SAFE_INTEGER;
};

/**
 * @param {Array} screenings
 * @param {(screening: object) => string|null} media_id_of
 * @param {(screening: object) => string} [cluster_of] splits one media id when the poster or Eventival link differs
 * @returns {{ total: number, with_id: number, without_id: number, groups: Array<{ media_id: string, cluster: string, screenings: object[] }> }}
 */
export const group_vod_screenings = (screenings, media_id_of, cluster_of = () => '') => {
    const by_id = new Map();
    let with_id = 0;
    let without_id = 0;

    for (const screening of screenings || []) {
        const media_id = media_id_of(screening);
        if (!media_id) {
            without_id += 1;
            continue;
        }

        with_id += 1;
        const cluster = String(cluster_of(screening) || '');
        const key = `${media_id}\u0000${cluster}`;
        if (!by_id.has(key))
            by_id.set(key, { media_id, cluster, screenings: [] });
        by_id.get(key).screenings.push(screening);
    }

    const groups = [...by_id.values()];
    for (const group of groups)
        group.screenings.sort((a, b) => start_ms(a) - start_ms(b) || String(a?._id || '').localeCompare(String(b?._id || '')));

    groups.sort((a, b) => (
        start_ms(a.screenings[0]) - start_ms(b.screenings[0])
        || a.media_id.localeCompare(b.media_id)
    ));

    return {
        total: with_id + without_id,
        with_id,
        without_id,
        groups,
    };
};
